import axios from 'axios';
import { bundle } from '../../helpers';
import { handleErrors, paramBuilder, headerBuilder } from '../http';

var backgroundJobPath = function backgroundJobPath(job) {
  return job ? job.parentType === 'Datastore' ? "".concat(bundle.apiLocation(), "/datastore/forms/").concat(job.parent.slug, "/backgroundJobs/").concat(job.id || '') : null : "".concat(bundle.apiLocation(), "/backgroundJobs");
};

export var fetchBackgroundJobs = function fetchBackgroundJobs() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.get(backgroundJobPath(), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      backgroundJobs: response.data.backgroundJobs
    };
  })["catch"](handleErrors);
};
export var createBackgroundJob = function createBackgroundJob() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var job = options.job,
      type = options.type,
      content = options.content;
  var path = backgroundJobPath(job);

  if (job === null) {
    throw new Error("createBackgroundJob failed! Property \"job\" is required.");
  }

  if (path === null) {
    throw new Error("createBackgroundJob failed! Unsupported parentType: 'job.parentType'");
  }

  return axios.post(path, {
    type: type,
    content: content
  }).then(function (response) {
    return {
      backgroundJob: response.data.backgroundJob
    };
  })["catch"](handleErrors);
};
export var updateBackgroundJob = function updateBackgroundJob() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var job = options.job,
      status = options.status;
  var path = backgroundJobPath(job);

  if (job === null) {
    throw new Error("updateBackgroundJob failed! Property \"job\" is required.");
  }

  if (path === null) {
    throw new Error("updateBackgroundJob failed! Unsupported parentType: 'job.parentType'");
  }

  return axios.put(path, {
    status: status
  }, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      backgroundJob: response.data.backgroundJob
    };
  })["catch"](handleErrors);
};
export var deleteBackgroundJob = function deleteBackgroundJob() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var job = options.job;
  var path = backgroundJobPath(job);

  if (job === null) {
    throw new Error("deleteBackgroundJob failed! Property \"job\" is required.");
  }

  if (path === null) {
    throw new Error("deleteBackgroundJob failed! Unsupported parentType: 'job.parentType'");
  }

  return axios["delete"](path, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      backgroundJob: response.data.backgroundJob
    };
  })["catch"](handleErrors);
};